import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportNationalStockPage } from './report-national-stock.page';

const routes: Routes = [
  {
    path: '',
    component: ReportNationalStockPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportNationalStockPageRoutingModule {}
